import { IWidgetComponentProps, getWidgetProps } from '@framework/engine';
import { isOmissisEnabled } from '../../directives/omissis/OmissisDirective.type';
import { IUploadWidget, UploadButtonsLayout } from './IUploadWidget';
import { publicDataUploadWidgetName } from './UploadWidget.type';
import { ButtonsLayout } from './components/ButtonsLayout';
import { UploadWidgetReadonlyCompontentInput } from './components/UploadWidgetReadonlyCompontentInput';

export interface IUploadWidgetReadonlyComponentProps
  extends IWidgetComponentProps<IUploadWidget> {}

/**
 * Componente di upload in modalità readonly
 * @param props
 * @returns
 */
export function UploadWidgetReadonlyComponent(
  props: IUploadWidgetReadonlyComponentProps,
) {
  const options = getWidgetProps(props);

  const privateWidgetName = options.name;
  const publicWidgetName = publicDataUploadWidgetName(options.name);
  const omissisEnabled = isOmissisEnabled(props.widget);

  return (
    <ButtonsLayout
      hasOmissis={omissisEnabled}
      horizontal={
        props.widget.layout?.buttonLayout == UploadButtonsLayout.Horizontal
      }
    >
      <UploadWidgetReadonlyCompontentInput
        {...props}
        widgetName={privateWidgetName}
      />
      {omissisEnabled && (
        <UploadWidgetReadonlyCompontentInput
          {...props}
          widgetName={publicWidgetName}
          publicUpload
        />
      )}
    </ButtonsLayout>
  );
}
